const removeProtocol = (url: string) => {
  return url.replace(/^https?:\/\//, '')
}

export default removeProtocol
